import { useRef } from "react";
import type { TextRenderBlock } from "@/lib/chat-render";
import { ChatMessage } from "./ChatMessage";
import { useStreamingReveal } from "./useStreamingReveal";

/**
 * 生成中のテキストを、確定済みアシスタント応答と同じ描画ブロックへ載せる。
 * 確定行が届いたらストアの暫定状態が消え、そのまま本物のブロックへ置き換わる。
 */
function streamingRenderBlock(text: string): TextRenderBlock {
	return {
		kind: "text",
		key: "streaming-assistant",
		messageId: "streaming-assistant",
		role: "assistant",
		text,
		controls: [],
		images: [],
		documents: [],
		uploadedFiles: [],
		createdAt: "",
		createdById: null,
		sendStatus: "sent",
	};
}

interface StreamingAssistantMessageProps {
	text: string;
	/** 履歴検索での位置。確定済みブロックの後ろに並ぶ。 */
	searchIndex: number;
}

export function StreamingAssistantMessage({ text, searchIndex }: StreamingAssistantMessageProps) {
	const rootRef = useRef<HTMLDivElement>(null);
	useStreamingReveal(rootRef, text);
	return (
		<div data-testid="streaming-assistant" data-search-index={searchIndex} ref={rootRef}>
			<ChatMessage message={streamingRenderBlock(text)} />
		</div>
	);
}
